// extracted by mini-css-extract-plugin
export default {"resolveFailureDialog":"s3XQ5","submissionMessage":"WFlxK"};